/** @format */

import { Tab, Tabs, Tooltip } from '@mui/material';
import { useState, type CSSProperties } from 'react';
import { Button } from 'src/components';
import {
  AppsIcon,
  ArrowDownIcon,
  BackArrowIcon,
  ChevronRight,
  CrossIcon,
  DeleteIcon,
  ExitIcon,
  FilterIcon,
  GlobeIcon,
  HomeIcon,
  PersonIcon,
  SearchIcon,
  TopicsIcon,
  TagsIcon,
  UploadIcon,
  PlusIcon,
  ThreedotsIcon,
  EditIcon,
  HideIcon,
  PrintIcon,
  ShareIcon,
  SettingIcon,
  ViewIcon,
  DownloadIcon,
  ExtLinkIcon
} from 'src/components/icons';

const iconItemStyle: CSSProperties = {
  border: '1px solid #e6e6e6',
  borderRadius: 8,
  padding: 16,
  gap: 8,
  textAlign: 'center',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center'
};

export default function Components() {
  const [activeTab, setActiveTab] = useState('button');

  return (
    <div style={{ marginTop: 24 }}>
      <div className="container">
        <Tabs
          value={activeTab}
          onChange={(_, value) => setActiveTab(value)}
          indicatorColor="primary"
          textColor="primary"
          style={{ marginBottom: 24 }}>
          <Tab label="Button" value="button" />
          <Tab label="Icon" value="icon" />
        </Tabs>

        {activeTab === 'button' && (
          <>
            <h4>Primary</h4>
            <div
              style={{
                marginTop: 10,
                marginBottom: 10,
                display: 'flex',
                gap: 16,
                flexWrap: 'wrap',
                alignItems: 'center',
                paddingBottom: 20
              }}>
              <Tooltip arrow title="primary" placement="top">
                <div>
                  <Button label="Button" />
                </div>
              </Tooltip>
              <Tooltip arrow title="primary disabled" placement="top">
                <div>
                  <Button disabled label="Button" />
                </div>
              </Tooltip>
              <Tooltip arrow title="primary arrow" placement="top">
                <div>
                  <Button arrow label="Button" />
                </div>
              </Tooltip>
              <Tooltip arrow title="primary arrow disabled" placement="top">
                <div>
                  <Button arrow disabled label="Button" />
                </div>
              </Tooltip>
              <Tooltip arrow title="primary check" placement="top">
                <div>
                  <Button check label="Button" />
                </div>
              </Tooltip>
              <Tooltip arrow title="primary check disabled" placement="top">
                <div>
                  <Button check disabled label="Button" />
                </div>
              </Tooltip>
            </div>
            <h4>Secondary</h4>
            <div
              style={{
                marginTop: 10,
                marginBottom: 10,
                display: 'flex',
                gap: 16,
                flexWrap: 'wrap',
                alignItems: 'center',
                paddingBottom: 20
              }}>
              <Tooltip arrow title="secondary" placement="top">
                <div>
                  <Button secondary label="Button" />
                </div>
              </Tooltip>
              <Tooltip arrow title="secondary disabled" placement="top">
                <div>
                  <Button secondary disabled label="Button" />
                </div>
              </Tooltip>
              <Tooltip arrow title="secondary arrow" placement="top">
                <div>
                  <Button secondary arrow label="Button" />
                </div>
              </Tooltip>
              <Tooltip arrow title="secondary arrow disabled" placement="top">
                <div>
                  <Button secondary arrow disabled label="Button" />
                </div>
              </Tooltip>
              <Tooltip arrow title="secondary check" placement="top">
                <div>
                  <Button secondary check label="Button" />
                </div>
              </Tooltip>
              <Tooltip arrow title="secondary check disabled" placement="top">
                <div>
                  <Button secondary check disabled label="Button" />
                </div>
              </Tooltip>
            </div>
            <h4>Small</h4>
            <div
              style={{
                marginTop: 10,
                marginBottom: 10,
                display: 'flex',
                gap: 16,
                flexWrap: 'wrap',
                alignItems: 'center',
                paddingBottom: 20
              }}>
              <Tooltip arrow title="small" placement="top">
                <div>
                  <Button small label="Button" />
                </div>
              </Tooltip>
              <Tooltip arrow title="small disabled" placement="top">
                <div>
                  <Button small disabled label="Button" />
                </div>
              </Tooltip>
              <Tooltip arrow title="small arrow" placement="top">
                <div>
                  <Button small arrow label="Button" />
                </div>
              </Tooltip>
              <Tooltip arrow title="small arrow disabled" placement="top">
                <div>
                  <Button small arrow disabled label="Button" />
                </div>
              </Tooltip>
              <Tooltip arrow title="small check" placement="top">
                <div>
                  <Button small check label="Button" />
                </div>
              </Tooltip>
              <Tooltip arrow title="small check disabled" placement="top">
                <div>
                  <Button small check disabled label="Button" />
                </div>
              </Tooltip>
            </div>
            <h4>Small Secondary</h4>
            <div
              style={{
                marginTop: 10,
                marginBottom: 10,
                display: 'flex',
                gap: 16,
                flexWrap: 'wrap',
                alignItems: 'center',
                paddingBottom: 20
              }}>
              <Tooltip arrow title="secondary small" placement="top">
                <div>
                  <Button secondary small label="Button" />
                </div>
              </Tooltip>
              <Tooltip arrow title="secondary small disabled" placement="top">
                <div>
                  <Button secondary small disabled label="Button" />
                </div>
              </Tooltip>
              <Tooltip arrow title="secondary small arrow" placement="top">
                <div>
                  <Button secondary small arrow label="Button" />
                </div>
              </Tooltip>
              <Tooltip arrow title="secondary small arrow disabled" placement="top">
                <div>
                  <Button secondary small arrow disabled label="Button" />
                </div>
              </Tooltip>
              <Tooltip arrow title="secondary small check" placement="top">
                <div>
                  <Button secondary small check label="Button" />
                </div>
              </Tooltip>
              <Tooltip arrow title="secondary small check disabled" placement="top">
                <div>
                  <Button secondary small check disabled label="Button" />
                </div>
              </Tooltip>
            </div>
            <h4>Text</h4>
            <div
              style={{
                marginTop: 10,
                marginBottom: 10,
                display: 'flex',
                gap: 16,
                flexWrap: 'wrap',
                alignItems: 'center',
                paddingBottom: 20
              }}>
              <Tooltip arrow title="text" placement="top">
                <div>
                  <Button text label="Button" />
                </div>
              </Tooltip>
              <Tooltip arrow title="text disabled" placement="top">
                <div>
                  <Button text disabled label="Button" />
                </div>
              </Tooltip>
              <Tooltip arrow title="text arrow" placement="top">
                <div>
                  <Button text arrow label="Button" />
                </div>
              </Tooltip>
              <Tooltip arrow title="text arrow disabled" placement="top">
                <div>
                  <Button text arrow disabled label="Button" />
                </div>
              </Tooltip>
              <Tooltip arrow title="text check" placement="top">
                <div>
                  <Button text check label="Button" />
                </div>
              </Tooltip>
              <Tooltip arrow title="text check disabled" placement="top">
                <div>
                  <Button text check disabled label="Button" />
                </div>
              </Tooltip>
            </div>
            <h4>Text Secondary</h4>
            <div
              style={{
                marginTop: 10,
                marginBottom: 10,
                display: 'flex',
                gap: 16,
                flexWrap: 'wrap',
                alignItems: 'center',
                paddingBottom: 20
              }}>
              <Tooltip arrow title="text small" placement="top">
                <div>
                  <Button text small label="Button" />
                </div>
              </Tooltip>
              <Tooltip arrow title="text small disabled" placement="top">
                <div>
                  <Button text small disabled label="Button" />
                </div>
              </Tooltip>
              <Tooltip arrow title="text small arrow" placement="top">
                <div>
                  <Button text small arrow label="Button" />
                </div>
              </Tooltip>
              <Tooltip arrow title="text small arrow disabled" placement="top">
                <div>
                  <Button text small arrow disabled label="Button" />
                </div>
              </Tooltip>
              <Tooltip arrow title="text small check" placement="top">
                <div>
                  <Button text small check label="Button" />
                </div>
              </Tooltip>
              <Tooltip arrow title="text small check disabled" placement="top">
                <div>
                  <Button text small check disabled label="Button" />
                </div>
              </Tooltip>
            </div>
          </>
        )}

        {activeTab === 'icon' && (
          <>
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(140px, 1fr))',
                gap: 16,
                marginBottom: 24
              }}>
              <div style={iconItemStyle}>
                <AppsIcon color="#1F1F1F" />
                <div>AppsIcon</div>
              </div>
              <div style={iconItemStyle}>
                <HomeIcon />
                <div>HomeIcon</div>
              </div>
              <div style={iconItemStyle}>
                <ChevronRight color="#1F1F1F" />
                <div>ChevronRight</div>
              </div>
              <div style={iconItemStyle}>
                <UploadIcon />
                <div>UploadIcon</div>
              </div>
              <div style={iconItemStyle}>
                <ExitIcon />
                <div>ExitIcon</div>
              </div>
              <div style={iconItemStyle}>
                <PersonIcon />
                <div>PersonIcon</div>
              </div>
              <div style={iconItemStyle}>
                <DeleteIcon />
                <div>DeleteIcon</div>
              </div>
              <div style={iconItemStyle}>
                <BackArrowIcon />
                <div>BackArrowIcon</div>
              </div>
              <div style={iconItemStyle}>
                <SearchIcon />
                <div>SearchIcon</div>
              </div>
              <div style={iconItemStyle}>
                <GlobeIcon />
                <div>GlobeIcon</div>
              </div>
              <div style={iconItemStyle}>
                <FilterIcon />
                <div>FilterIcon</div>
              </div>
              <div style={iconItemStyle}>
                <ArrowDownIcon />
                <div>ArrowDownIcon</div>
              </div>
              <div style={iconItemStyle}>
                <CrossIcon width={16} height={16} />
                <div>CrossIcon</div>
              </div>
              <div style={iconItemStyle}>
                <TopicsIcon />
                <div>TopicsIcon</div>
              </div>
              <div style={iconItemStyle}>
                <TagsIcon />
                <div>TagsIcon</div>
              </div>
              <div style={iconItemStyle}>
                <PlusIcon />
                <div>PlusIcon</div>
              </div>
              <div style={iconItemStyle}>
                <ThreedotsIcon />
                <div>ThreedotsIcon</div>
              </div>
              <div style={iconItemStyle}>
                <EditIcon />
                <div>EditIcon</div>
              </div>
              <div style={iconItemStyle}>
                <HideIcon />
                <div>HideIcon</div>
              </div>
              <div style={iconItemStyle}>
                <PrintIcon />
                <div>PrintIcon</div>
              </div>
              <div style={iconItemStyle}>
                <ShareIcon />
                <div>ShareIcon</div>
              </div>
              <div style={iconItemStyle}>
                <SettingIcon />
                <div>SettingIcon</div>
              </div>
              <div style={iconItemStyle}>
                <ViewIcon />
                <div>ViewIcon</div>
              </div>
              <div style={iconItemStyle}>
                <DownloadIcon />
                <div>DownloadIcon</div>
              </div>
              <div style={iconItemStyle}>
                <ExtLinkIcon width={16} height={16} />
                <div>ExtLinkIcon</div>
              </div>
            </div>
          </>
        )}
      </div>
      {activeTab === 'button' && (
        <div style={{ marginTop: 24, backgroundColor: '#003159', color: 'white', paddingTop: 24, paddingBottom: 24 }}>
          <div className="container">
            <h4>Dark Primary</h4>
            <div
              style={{
                marginTop: 10,
                marginBottom: 10,
                display: 'flex',
                gap: 16,
                flexWrap: 'wrap',
                alignItems: 'center',
                paddingBottom: 20
              }}>
              <Tooltip arrow title="dark primary" placement="top">
                <div>
                  <Button dark label="Button" />
                </div>
              </Tooltip>
              <Tooltip arrow title="dark primary disabled" placement="top">
                <div>
                  <Button dark disabled label="Button" />
                </div>
              </Tooltip>
              <Tooltip arrow title="dark primary arrow" placement="top">
                <div>
                  <Button dark arrow label="Button" />
                </div>
              </Tooltip>
              <Tooltip arrow title="dark primary arrow disabled" placement="top">
                <div>
                  <Button dark arrow disabled label="Button" />
                </div>
              </Tooltip>
              <Tooltip arrow title="dark primary check" placement="top">
                <div>
                  <Button dark check label="Button" />
                </div>
              </Tooltip>
              <Tooltip arrow title="dark primary check disabled" placement="top">
                <div>
                  <Button dark check disabled label="Button" />
                </div>
              </Tooltip>
            </div>
            <h4>Dark Secondary</h4>
            <div
              style={{
                marginTop: 10,
                marginBottom: 10,
                display: 'flex',
                gap: 16,
                flexWrap: 'wrap',
                alignItems: 'center',
                paddingBottom: 20
              }}>
              <Tooltip arrow title="dark secondary" placement="top">
                <div>
                  <Button dark secondary label="Button" />
                </div>
              </Tooltip>
              <Tooltip arrow title="dark secondary disabled" placement="top">
                <div>
                  <Button dark secondary disabled label="Button" />
                </div>
              </Tooltip>
              <Tooltip arrow title="dark secondary arrow" placement="top">
                <div>
                  <Button dark secondary arrow label="Button" />
                </div>
              </Tooltip>
              <Tooltip arrow title="dark secondary arrow disabled" placement="top">
                <div>
                  <Button dark secondary arrow disabled label="Button" />
                </div>
              </Tooltip>
              <Tooltip arrow title="dark secondary check" placement="top">
                <div>
                  <Button dark secondary check label="Button" />
                </div>
              </Tooltip>
              <Tooltip arrow title="dark secondary check disabled" placement="top">
                <div>
                  <Button dark secondary check disabled label="Button" />
                </div>
              </Tooltip>
            </div>
            <h4>Dark Small</h4>
            <div
              style={{
                marginTop: 10,
                marginBottom: 10,
                display: 'flex',
                gap: 16,
                flexWrap: 'wrap',
                alignItems: 'center',
                paddingBottom: 20
              }}>
              <Tooltip arrow title="dark small" placement="top">
                <div>
                  <Button dark small label="Button" />
                </div>
              </Tooltip>
              <Tooltip arrow title="dark small disabled" placement="top">
                <div>
                  <Button dark small disabled label="Button" />
                </div>
              </Tooltip>
              <Tooltip arrow title="dark small arrow" placement="top">
                <div>
                  <Button dark small arrow label="Button" />
                </div>
              </Tooltip>
              <Tooltip arrow title="dark small arrow disabled" placement="top">
                <div>
                  <Button dark small arrow disabled label="Button" />
                </div>
              </Tooltip>
              <Tooltip arrow title="dark small check" placement="top">
                <div>
                  <Button dark small check label="Button" />
                </div>
              </Tooltip>
              <Tooltip arrow title="dark small check disabled" placement="top">
                <div>
                  <Button dark small check disabled label="Button" />
                </div>
              </Tooltip>
            </div>
            <h4>Dark Small Secondary</h4>
            <div
              style={{
                marginTop: 10,
                marginBottom: 10,
                display: 'flex',
                gap: 16,
                flexWrap: 'wrap',
                alignItems: 'center',
                paddingBottom: 20
              }}>
              <Tooltip arrow title="dark small secondary" placement="top">
                <div>
                  <Button dark small secondary label="Button" />
                </div>
              </Tooltip>
              <Tooltip arrow title="dark small secondary disabled" placement="top">
                <div>
                  <Button dark small secondary disabled label="Button" />
                </div>
              </Tooltip>
              <Tooltip arrow title="dark small secondary arrow" placement="top">
                <div>
                  <Button dark small secondary arrow label="Button" />
                </div>
              </Tooltip>
              <Tooltip arrow title="dark small secondary arrow disabled" placement="top">
                <div>
                  <Button dark small secondary arrow disabled label="Button" />
                </div>
              </Tooltip>
              <Tooltip arrow title="dark small secondary check" placement="top">
                <div>
                  <Button dark small secondary check label="Button" />
                </div>
              </Tooltip>
              <Tooltip arrow title="dark small secondary check disabled" placement="top">
                <div>
                  <Button dark small secondary check disabled label="Button" />
                </div>
              </Tooltip>
            </div>
            <h4>Dark Text</h4>
            <div
              style={{
                marginTop: 10,
                marginBottom: 10,
                display: 'flex',
                gap: 16,
                flexWrap: 'wrap',
                alignItems: 'center',
                paddingBottom: 20
              }}>
              <Tooltip arrow title="dark text" placement="top">
                <div>
                  <Button dark text label="Button" />
                </div>
              </Tooltip>
              <Tooltip arrow title="dark text disabled" placement="top">
                <div>
                  <Button dark text disabled label="Button" />
                </div>
              </Tooltip>
            </div>
            <h4>Dark Text Secondary</h4>
            <div
              style={{
                marginTop: 10,
                marginBottom: 10,
                display: 'flex',
                gap: 16,
                flexWrap: 'wrap',
                alignItems: 'center',
                paddingBottom: 20
              }}>
              <Tooltip arrow title="dark text small secondary" placement="top">
                <div>
                  <Button dark text small secondary label="Button" />
                </div>
              </Tooltip>
              <Tooltip arrow title="dark text small secondary disabled" placement="top">
                <div>
                  <Button dark text small secondary disabled label="Button" />
                </div>
              </Tooltip>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
